const referralList = {
  name: "Referral",
  children: [
    "SORSI",
    "Dr Kelli",
    "Brain Injury Group",
    "Provider",
    "Media-Conference",
    "Clinic",
    "Sandy Pruett Project",
    "none",
  ],
};

export default referralList;
